import type { Window } from "@rua-watch/shared";

const WINDOWS: Window[] = ["24h", "7d", "30d", "90d"];

// Pill-style segmented control. Active button inverts colors per
// theme so it stays legible in both modes — a single dark fill
// vanishes against the dark sidebar/main background.
export function WindowPicker({
  value,
  onChange,
}: {
  value: Window;
  onChange: (w: Window) => void;
}) {
  return (
    <div className="inline-flex overflow-hidden rounded-md border border-slate-300 bg-white text-sm dark:border-slate-700 dark:bg-slate-900">
      {WINDOWS.map((w) => {
        const active = value === w;
        const base = "px-3 py-1.5 transition-colors";
        const styles = active
          ? "bg-slate-900 text-white dark:bg-slate-100 dark:text-slate-900"
          : "text-slate-700 hover:bg-slate-100 dark:text-slate-300 dark:hover:bg-slate-800";
        return (
          <button
            key={w}
            onClick={() => onChange(w)}
            className={`${base} ${styles}`}
            aria-pressed={active}
          >
            {w}
          </button>
        );
      })}
    </div>
  );
}
